export const file_types = [
    { id: 'video', file_type: { az: 'video', en: 'video', ru: 'видео' } },
    { id: 'image', file_type: { az: 'şəkil', en: 'image', ru: 'изображение' } }
];
